import { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { DataContext } from 'providers/data';

import * as Regex from 'utils/validations';
import { DecodeToken } from 'utils/decodeToken';
import { ParamsPaymentForms } from 'utils/typeServices';

import { Box, Typography, Fade } from '@mui/material';

import Menu from 'components/views/Menu';
import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import CarouselCars from 'components/views/CarouselCars';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';
import { ModalConfirmChange, ModalSuccessBillingPaymentMethod, ModalErrorBillingPaymentMethod, ModalEmailBillingPaymentMethodTicket, ModalConfirmChangeDueDate, ModalErrorBillingPaymentMethodDeadline } from 'components/views/Invoices/Modals';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';

import { ContainerBody, ContentBody, TypographyTitle, ContentDetails } from '../styles';

type FormData = {
    digit: string;
    agency: string;
    identity: string;
    company_name: string;
    account_number: string;
}

type ParamsSelected = {
    text: string;
    value: string;
}

const datePayment = [
    {
        text: '5',
        value: '5'
    },
    {
        text: '10',
        value: '10'
    },
    {
        text: '15',
        value: '15'
    },
    {
        text: '20',
        value: '20'
    },
    {
        text: '25',
        value: '25'
    }
]

const ChangePayment = () => {
    const { state } = useLocation();
    const { customerCars, customerPaymentForms, listPaymentAvailable, selectedCar, dataChangeBillingPaymentMethod, dataChangeBillingPaymentDueDate, dataValidateSolicitationDate, handleGetPaymentForms, handleGetPaymentAvailable, handlePostChangeBillingPaymentMethod, handlePostChangeBillingPaymentDueDate, handlePostValidateSolicitationDate } = useContext(DataContext);

    const [dateChange, setDateChange] = useState('');
    const [showFocus, setShowFocus] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isBtnActive, setIsBtnActive] = useState(false);
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [confirmEmail, setConfirmEmail] = useState(false);
    const [showModalEmail, setShowModalEmail] = useState(false);
    const [isChangePayment, setIsChangePayment] = useState(false);
    const [isOpenModalDueDate, setIsOpenModalDueDate] = useState(false);
    const [datePaymentState, setDatePaymentState] = useState(datePayment);
    const [isChangeDate, setIsChangeDate] = useState(false);
    const [customerPaymentFormsState, setCustomerPaymentFormsState] = useState<ParamsPaymentForms>();
    const [showModalErrorBillingPaymentMethod, setShowModalErrorBillingPaymentMethod] = useState(false);
    const [paymentFormsList, setPaymentFormsList] = useState<Array<{ text: string, value: string }>>([]);
    const [showModalSuccessBillingPaymentMethod, setShowModalSuccessBillingPaymentMethod] = useState(false);
    const [showModalErrorBillingPaymentMethodDeadline, setShowModalErrorBillingPaymentMethodDeadline] = useState(false);
    const [bankList, setBankList] = useState<Array<ParamsSelected>>([]);
    const [itemSelectedState, setItemSelectedState] = useState({
        text: '',
        value: ''
    });
    const [dateSelected, setDateSelected] = useState({
        text: '',
        value: ''
    });
    const [bankSelected, setBankSelected] = useState({
        text: '',
        value: ''
    });

    const { register, handleSubmit, watch, setValue } = useForm<FormData>();

    const digit = watch('digit');
    const agency = watch('agency');
    const identity = watch('identity');
    const company_name = watch('company_name');
    const account_number = watch('account_number');

    const handleChassi = (NR_PLATAFORMA_SELECTED: number) => {
        const carSelected = customerCars?.find(({ NR_PLATAFORMA }) => NR_PLATAFORMA_SELECTED === NR_PLATAFORMA);

        return carSelected ? carSelected.CHASSI : '';
    }

    const handlePostValidateSolicitationDateState = (NR_PLATAFORMA: number) => {
        handlePostValidateSolicitationDate({ body: { CD_TIPO_OCORRENCIA: 1414, NR_PLATAFORMA } });
    }

    const handleIsChanged = (e: { text: string; value: string }) => {
        if (e.value !== itemSelectedState.value) {
            setItemSelectedState(e);

            handleGetPaymentAvailable({ token: localStorage.getItem('token')!, type: parseFloat(e.value) });
            // handleGetServiceTerms({ token: localStorage.getItem('token')!, type: parseFloat(e.value) === 22 ? 1 : 2 });

            if (e.value === `${customerPaymentFormsState?.PaymentFormTypeId}`) {
                setIsChanged(false);
            } else {
                setIsChanged(true);
            }
        }
    }

    // const handleOpenDueDate = () => {
    //     if (dataValidateSolicitationDate && !dataValidateSolicitationDate.PermiteAlteracao) {
    //         setShowModalErrorBillingPaymentMethodDeadline(true);
    //         return;
    //     }
    //     setIsOpenModalDueDate(true);
    // };

    const onSubmit = () => {
        if (dataValidateSolicitationDate && !dataValidateSolicitationDate.PermiteAlteracao) {
            setShowModalErrorBillingPaymentMethodDeadline(true);
            return;
        }

        itemSelectedState.value === '22' && setIsOpenModal(true);
        itemSelectedState.value === '25' && setShowModalEmail(true);
    }

    const handleClickConfirmDueDate = (e: boolean) => {
        e && setIsBtnLoading(true);
        setIsOpenModalDueDate(false);

        if (e && customerPaymentFormsState && dateSelected) {
            handlePostChangeBillingPaymentDueDate({
                body: {
                    NrPlataforma: customerPaymentFormsState.Id,
                    PaymentDueDate: parseFloat(dateSelected.value)
                }
            });
        }
    }

    const resetSelected = () => {
        setIsChanged(false);
        setIsChangeDate(false);
        setIsChangePayment(false);

        if (customerPaymentForms && selectedCar) {
            const customerPaymentFormsSelected = customerPaymentForms.find(({ Id }) => selectedCar.NR_PLATAFORMA === Id);
            customerPaymentFormsSelected && setItemSelectedState({ text: customerPaymentFormsSelected.PaymentFormTypeName, value: `${customerPaymentFormsSelected.PaymentFormTypeId}` });
        }
    }

    const handleClickConfirm = (e: boolean) => {
        setIsBtnLoading(true);
        setIsOpenModal(false);
        !e && setIsBtnLoading(false);
        const token = DecodeToken();

        if (e && listPaymentAvailable && token && customerPaymentFormsState) {
            if (itemSelectedState.value === '22') {
                const bank = listPaymentAvailable?.find(({ PaymentId }) => PaymentId === parseFloat(bankSelected.value));

                if (bank) {
                    handlePostChangeBillingPaymentMethod({
                        token: localStorage.getItem('token')!,
                        body: {
                            BankAccount: {
                                FirstName: company_name,
                                LastName: '',
                                CpfNumber: identity,
                                BankCode: bank.BankNumber,
                                AgencyCode: agency,
                                OperationNumber: 0,
                                AccountNumber: account_number,
                                AccountDigit: digit,
                            },
                            NrPlataforma: customerPaymentFormsState.Id,
                            PaymentMethodTypeId: bank.PaymentTypeId,
                            PaymentMethodId: bank.PaymentId,
                        }
                    });
                }
            } else {
                handlePostChangeBillingPaymentMethod({
                    token: localStorage.getItem('token')!,
                    body: {
                        BankAccount: {
                            FirstName: company_name,
                            LastName: '',
                            CpfNumber: identity,
                            BankCode: listPaymentAvailable[0].BankNumber,
                            AgencyCode: '',
                            OperationNumber: 0,
                            AccountNumber: '',
                            AccountDigit: '',
                        },
                        NrPlataforma: customerPaymentFormsState.Id,
                        PaymentMethodTypeId: listPaymentAvailable[0].PaymentTypeId,
                        PaymentMethodId: listPaymentAvailable[0].PaymentId,
                    }
                });
            }
        }
    }

    useEffect(() => {
        if (itemSelectedState.value === '22') {
            if (digit && agency && account_number && bankSelected) {
                setIsBtnActive(true);
            } else {
                setIsBtnActive(false);
            }
        } else {
            setIsBtnActive(true);
        }

    }, [digit, agency, account_number, bankSelected, itemSelectedState]);

    useEffect(() => {
        if (!customerPaymentForms) {
            handleGetPaymentForms({ token: localStorage.getItem('token')! });
        }

        if (state?.showFocus && !showFocus) {
            setShowFocus(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (selectedCar) {
            setValue('identity', selectedCar.NR_CNPJ_CPF);
            setValue('company_name', selectedCar.NOME_CLIENTE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (customerPaymentForms && customerPaymentForms?.length > 0 && selectedCar) {
            let datePaymentStateAux = datePaymentState;
            const customerPaymentFormsSelected = customerPaymentForms.find(({ Id }) => selectedCar.NR_PLATAFORMA === Id);
            if (customerPaymentFormsSelected) {
                let paymentForms = [
                    {
                        text: 'Débito em Conta',
                        value: '22'
                    }
                ];

                setItemSelectedState({
                    text: customerPaymentFormsSelected.PaymentFormTypeName,
                    value: `${customerPaymentFormsSelected.PaymentFormTypeId}`
                });

                customerPaymentFormsSelected.PaymentFormTypeId === 22 && paymentForms.push({ text: 'Boleto eletrônico', value: '25' });

                if ([22, 25].indexOf(customerPaymentFormsSelected.PaymentFormTypeId) < 0) {
                    paymentForms.push({
                        text: customerPaymentFormsSelected.PaymentFormTypeName,
                        value: `${customerPaymentFormsSelected.PaymentFormTypeId}`
                    });
                }

                setPaymentFormsList(paymentForms);

                if (!datePaymentState.find(({ value }) => customerPaymentFormsSelected?.NR_DIA_VENCIMENTO === parseFloat(value))) {
                    datePaymentStateAux.push({
                        text: `${customerPaymentFormsSelected?.NR_DIA_VENCIMENTO}`,
                        value: `${customerPaymentFormsSelected?.NR_DIA_VENCIMENTO}`
                    });
                    setDatePaymentState(datePaymentStateAux);
                }

                setDateSelected({
                    text: `${customerPaymentFormsSelected?.NR_DIA_VENCIMENTO}`,
                    value: `${customerPaymentFormsSelected?.NR_DIA_VENCIMENTO}`
                });

                setCustomerPaymentFormsState(customerPaymentFormsSelected);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerPaymentForms, selectedCar]);

    useEffect(() => {
        if (listPaymentAvailable) {
            let auxListBanks: Array<ParamsSelected> = [];

            listPaymentAvailable.map(({ Name, PaymentId }) =>
                auxListBanks.push({ text: Name, value: PaymentId.toString() })
            );

            auxListBanks && setBankList(auxListBanks);
        }
    }, [listPaymentAvailable]);

    useEffect(() => {
        if (showFocus) {
            setTimeout(() => {
                setShowFocus(false);
            }, 2000);
        }
    }, [showFocus]);

    useEffect(() => {
        setIsBtnLoading(false);
        if (dataChangeBillingPaymentMethod || dataChangeBillingPaymentDueDate) {
            setShowModalSuccessBillingPaymentMethod(true);
        } else if ((dataChangeBillingPaymentMethod === false) || (dataChangeBillingPaymentDueDate === false)) {
            setShowModalErrorBillingPaymentMethodDeadline(true);
        } else if ((dataChangeBillingPaymentMethod === null) || (dataChangeBillingPaymentDueDate === null)) {
            setShowModalErrorBillingPaymentMethod(true);
        }
    }, [dataChangeBillingPaymentMethod, dataChangeBillingPaymentDueDate]);

    useEffect(() => {
        if (confirmEmail) {
            setIsOpenModal(true);
            setConfirmEmail(false);
        }
    }, [confirmEmail]);

    useEffect(() => {
        if (selectedCar || customerPaymentForms) {
            resetSelected();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, customerPaymentForms]);

    useEffect(() => {
        if (selectedCar || customerPaymentForms) {
            resetSelected();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, customerPaymentForms]);

    useEffect(() => {
        if (selectedCar) {
            handlePostValidateSolicitationDateState(selectedCar?.NR_PLATAFORMA);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (dataValidateSolicitationDate && dataValidateSolicitationDate.DataUltimaAlteracao) {
            setDateChange(new Date(dataValidateSolicitationDate.DataUltimaAlteracao).toLocaleDateString('pt-BR'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataValidateSolicitationDate]);

    return (
        <Menu>
            <Box sx={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                display: showFocus ? 'flex' : 'none'
            }}>
                <Fade in={showFocus} {...(showFocus ? { timeout: 500 } : {})}>
                    <Box sx={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        zIndex: '1',
                        backgroundColor: 'rgba(12, 28, 51, 0.5)',
                    }} />
                </Fade>
            </Box>
            <ContainerBody className='changed-payment'>
                <Box sx={{
                    width: {
                        xs: '100%',
                        md: '70%'
                    },
                }}>
                    <ContentBody>
                        <Box sx={{
                            display: 'flex',
                            gap: '.4375rem',
                            alignItems: 'flex-end',
                            marginBottom: '1.64rem',
                            paddingBottom: '.56rem',
                            borderBottom: '1px solid rgba(141, 155, 181, 0.5)',
                        }}>
                            <Link to='/faturas'>
                                <Box sx={{
                                    width: '1.5rem',
                                    height: '1.5rem',
                                    borderRadius: '2px',
                                    display: 'flex',
                                    padding: '.15rem 0',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #0C1C33',
                                    'svg': {
                                        fill: '#0C1C33'
                                    }
                                }}>
                                    <ArrowBackIosNewIcon sx={{
                                        height: '100%'
                                    }} />
                                </Box>
                            </Link>
                            <Typography fontSize='1.25rem' fontWeight={700} color='primary.main' lineHeight='1'>
                                FATURAS
                            </Typography>
                        </Box>
                        <CarouselCars />
                    </ContentBody>
                    <Box sx={{
                        paddingTop: {
                            xs: '.375rem',
                            md: '1.75rem'
                        }
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'start', height: '2.5rem', justifyContent: 'flex-start', gap: '.625rem' }}>
                            <Box sx={{ width: '4px', height: '1.75rem', backgroundColor: 'secondary.main' }} />
                            <Typography
                                fontWeight={700}
                                paddingTop='.2rem'
                                sx={{
                                    fontSize: {
                                        xs: '1rem',
                                        md: '1.125rem'
                                    },
                                    maxWidth: {
                                        xs: '18rem',
                                        md: '100%'
                                    }
                                }}>
                                Alteração de forma de pagamento
                                {/* Alteração de forma de pagamento e/ou vencimento */}
                            </Typography>
                        </Box>
                        <Typography fontSize='.8175rem' sx={{
                            paddingTop: {
                                xs: '1.25rem',
                                md: '.5rem'
                            }
                        }}>
                            Clique abaixo e altere a forma de pagamento de sua fatura.
                            {/* Clique abaixo e altere a sua data de vencimento e/ou a forma de pagamento de sua fatura. */}
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            gap: {
                                xs: '0',
                                md: '3%'
                            },
                            padding: {
                                xs: '1.375rem 0 2.375rem',
                                md: '2.375rem 0'
                            },
                            justifyContent: 'start',
                            alignItems: 'center',
                            flexDirection: {
                                xs: 'column',
                                md: 'row'
                            }
                        }}>
                            <Typography fontSize='1.25rem' color='white' fontWeight={700} lineHeight={1}
                                sx={{
                                    width: '10.625rem',
                                    height: '3.375rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#0AA8E3',
                                    justifyContent: 'center',
                                    border: '1px solid #0AA8E3',
                                }}>
                                LEMBRETE
                            </Typography>
                            <Typography fontSize='.875rem' lineHeight='1.06rem' sx={{
                                maxWidth: '36.125rem',
                                border: '1px solid #0AA8E3',
                                padding: '.5rem 1.4375rem',
                            }}>
                                Todas as cobranças ativas para este veículo serão alteradas por meio desta solicitação
                                e uma nova alteração <strong>somente poderá ser solicitada após 60 dias.</strong>
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {customerPaymentFormsState ?
                    <Box sx={{
                        paddingBottom: {
                            xs: '3.375rem',
                            md: '0'
                        },
                    }}>
                        <Box sx={{ display: 'flex' }}>
                            <Typography fontSize='.8125rem' sx={{
                                paddingBottom: {
                                    xs: '.8125rem',
                                    md: '1rem'
                                }
                            }}>
                                Dados atuais:
                            </Typography>

                            {dataValidateSolicitationDate && !dataValidateSolicitationDate?.PermiteAlteracao &&
                                <Typography fontSize='.8125rem' sx={{ color: 'error.main', paddingLeft: '33.6%' }}>
                                    Alteração realizada em: <strong>{dateChange}</strong>
                                </Typography>
                            }
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                md: 'row'
                            }
                        }}>
                            <Box sx={{
                                width: {
                                    xs: '100%',
                                    md: '12%'
                                }
                            }}>
                                <TypographyTitle>
                                    Placa
                                </TypographyTitle>

                                <ContentDetails>
                                    <Typography
                                        fontSize='1rem'
                                        sx={{
                                            padding: {
                                                xs: '.375rem 0 .9375rem',
                                                md: '1.125rem 0 .9375rem',
                                            },
                                            overflow: 'hidden',
                                            whiteSpace: 'nowrap',
                                            maxWidth: '4.8rem',
                                            textOverflow: 'ellipsis',
                                        }}>
                                        {customerPaymentFormsState?.Plate ? customerPaymentFormsState?.Plate : handleChassi(customerPaymentFormsState?.Id)}
                                    </Typography>
                                </ContentDetails>
                            </Box>

                            {/* <Box sx={{
                                width: {
                                    xs: '100%',
                                    md: '25%'
                                }
                            }}>
                                <TypographyTitle
                                    sx={{
                                        paddingTop: {
                                            xs: '.75rem',
                                            md: '0'
                                        },
                                        textAlign: {
                                            xs: 'start',
                                            md: 'center'
                                        }
                                    }}>
                                    Data de vencimento
                                </TypographyTitle>

                                <ContentDetails sx={{
                                    display: 'flex',
                                    justifyContent: {
                                        xs: 'start',
                                        md: 'center'
                                    }
                                }} className='no-border'>
                                    <Box sx={{
                                        borderBottom: {
                                            xs: '1px solid #8D9BB5',
                                            md: 'none'
                                        },
                                        width: { xs: '100%', md: 'auto' },
                                        padding: {
                                            xs: '.375rem 0 1.25rem',
                                            md: '.375rem 0 .9375rem'
                                        }
                                    }}>
                                        <Box sx={{
                                            width: '100%',
                                            maxWidth: {
                                                xs: '100%',
                                                md: '12.5rem'
                                            },
                                            display: 'flex',
                                            flexDirection: {
                                                xs: 'row',
                                                md: 'column'
                                            },
                                            gap: '.875rem',
                                            'button': {
                                                width: {
                                                    xs: '38%',
                                                    md: '100%'
                                                }
                                            },
                                            zIndex: '3'
                                        }}>
                                            <Box sx={{ width: { xs: '58%', md: '100%' } }}>
                                                <Select
                                                    disabled={!isChangeDate}
                                                    itemSelected={dateSelected}
                                                    listItems={datePaymentState}
                                                    onChangeSelected={(e) => setDateSelected(e)}
                                                />
                                            </Box>
                                            <Box sx={{
                                                width: { xs: isChangeDate ? 'auto' : '38%', md: isChangeDate ? 'auto' : '100%' },
                                                display: 'flex',
                                                gap: { xs: '.5rem', md: '1.1875rem' },
                                                'button': {
                                                    width: { xs: '100%', md: '8.625rem' },
                                                    boxShadow: 'none',
                                                    height: '2.8125rem'
                                                }
                                            }}>
                                                <ButtonOutlined
                                                    name={isChangeDate ? 'CANCELAR' : 'ALTERAR'}
                                                    onClick={() => {
                                                        setIsChangeDate(!isChangeDate);
                                                        isChangeDate &&
                                                            setDateSelected({
                                                                text: `${customerPaymentFormsState?.NR_DIA_VENCIMENTO}`,
                                                                value: `${customerPaymentFormsState?.NR_DIA_VENCIMENTO}`
                                                            })
                                                    }
                                                    }
                                                />
                                                {dateSelected.value !== `${customerPaymentFormsState?.NR_DIA_VENCIMENTO}` &&
                                                    <ButtonRectangle
                                                        name='SALVAR'
                                                        loadingBtn={isBtnLoading}
                                                        onClick={() => handleOpenDueDate()}
                                                    />
                                                }
                                            </Box>
                                        </Box>
                                    </Box>
                                </ContentDetails>
                            </Box> */}

                            <Box sx={{
                                position: 'relative',
                                width: {
                                    xs: '100%',
                                    md: '63%'
                                }
                            }}>
                                <Box sx={{
                                    position: 'absolute',
                                    width: {
                                        xs: 'calc(100% + 1.2rem)',
                                        md: '52%'
                                    },
                                    height: {
                                        xs: '100%',
                                        md: '150%'
                                    },
                                    maxHeight: '168px',
                                    left: {
                                        xs: '-.6rem',
                                        md: '0'
                                    },
                                }}>
                                    <Fade in={showFocus} {...(showFocus ? { timeout: 500 } : {})}>
                                        <Box sx={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                        }}>
                                            <Typography sx={{
                                                fontWeight: 700,
                                                fontSize: {
                                                    xs: '1rem',
                                                    md: '1.125rem'
                                                },
                                                margin: {
                                                    xs: '-17px 0 .1rem',
                                                    md: '-44px 0 11px'
                                                },
                                                position: 'relative',
                                                zIndex: '2',
                                                color: 'white'
                                            }}>
                                                ATUALIZE AQUI
                                            </Typography>

                                            <Box sx={{
                                                width: '100%',
                                                height: '100%',
                                                maxWidth: {
                                                    xs: '100%',
                                                    md: '15.06rem'
                                                },
                                                borderRadius: '10px',
                                                backgroundColor: '#D9D9D9',
                                                zIndex: '2'
                                            }} />
                                        </Box>
                                    </Fade>
                                </Box>

                                <TypographyTitle
                                    sx={{
                                        width: '52%',
                                        paddingTop: {
                                            xs: '1.2rem',
                                            md: '0'
                                        },
                                        textAlign: {
                                            xs: 'start',
                                            md: 'center'
                                        },
                                        position: 'relative',
                                        zIndex: '3'
                                    }}>
                                    Forma de pagamento
                                </TypographyTitle>

                                <ContentDetails className='no-border' sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'start',
                                    flexDirection: 'column',
                                    borderLeft: {
                                        xs: 'none',
                                        md: '1px solid #8D9BB5'
                                    }
                                }}>
                                    <Box sx={{
                                        width: {
                                            xs: '100%',
                                            md: '53%'
                                        },
                                        display: 'flex',
                                        alignItems: {
                                            xs: 'flex-end',
                                            md: 'center'
                                        },
                                        padding: {
                                            xs: '.125rem 0 .9375rem',
                                            md: '.375rem 0 .9375rem'
                                        },
                                        justifyContent: {
                                            xs: 'space-between',
                                            md: 'flex-start'
                                        },
                                        flexDirection: {
                                            xs: 'row',
                                            md: 'column'
                                        }
                                    }}>
                                        <Box sx={{
                                            width: '100%',
                                            maxWidth: {
                                                xs: '100%',
                                                md: '12.5rem'
                                            },
                                            display: 'flex',
                                            flexDirection: {
                                                xs: 'row',
                                                md: 'column'
                                            },
                                            gap: '.875rem',
                                            'button': {
                                                width: {
                                                    xs: '38%',
                                                    md: '100%'
                                                },
                                                height: '2.8125rem'
                                            },
                                            zIndex: '3'
                                        }}>
                                            <Box sx={{ width: { xs: '58%', md: '100%' } }}>
                                                <Select
                                                    disabled={!isChangePayment}
                                                    itemSelected={itemSelectedState.value === '25' ? { text: '', value: '' } : itemSelectedState}
                                                    placeholder={itemSelectedState.text}
                                                    listItems={paymentFormsList}
                                                    onChangeSelected={(e) => handleIsChanged(e)}
                                                />
                                            </Box>
                                            {!isChanged &&
                                                <ButtonOutlined
                                                    name={isChangePayment ? 'CANCELAR' : 'ALTERAR'}
                                                    onClick={() => setIsChangePayment(!isChangePayment)}
                                                />
                                            }
                                        </Box>
                                    </Box>

                                    <Fade in={isChanged || (itemSelectedState.value === '22' && isChangePayment)} {...(isChanged ? { timeout: 500 } : {})}>
                                        <Box sx={{
                                            width: '100%',
                                            paddingLeft: {
                                                xs: '0',
                                                md: '12%'
                                            },
                                            display: isChanged || (itemSelectedState.value === '22' && isChangePayment) ? 'block' : 'none',
                                        }}>
                                            <Box sx={{ maxWidth: '23.867rem' }}>
                                                {itemSelectedState.value === '22' &&
                                                    <>
                                                        <Typography variant='subtitle2'>
                                                            <strong style={{
                                                                color: '#97C93D',
                                                                fontSize: '1.8rem',
                                                            }}>&middot;</strong>
                                                            &nbsp;
                                                            O titular da conta bancária deve ser o mesmo do cadastro Ituran.
                                                            <br />
                                                            <strong style={{
                                                                color: '#97C93D',
                                                                fontSize: '1.7rem'
                                                            }}>&middot;</strong>
                                                            &nbsp;
                                                            Válido apenas para contas individuais.
                                                        </Typography>
                                                        <Typography fontSize='1rem' fontWeight={700} padding="1.375rem 0">
                                                            Dados da conta bancária:
                                                        </Typography>
                                                    </>
                                                }
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    {itemSelectedState.value === '22' &&
                                                        <>
                                                            <Select
                                                                label='Banco'
                                                                itemSelected={bankSelected}
                                                                listItems={bankList}
                                                                onChangeSelected={(e) => setBankSelected(e)}
                                                            />
                                                            <Box sx={{
                                                                display: 'flex',
                                                                paddingTop: '1.25rem',
                                                                justifyContent: 'space-between',
                                                            }}>
                                                                <Box sx={{ maxWidth: '5rem' }}>
                                                                    <Input
                                                                        name='agency'
                                                                        label='Agência'
                                                                        placeholder='0000'
                                                                        type='text'
                                                                        register={{ ...register("agency", { required: true }) }}
                                                                    />
                                                                </Box>
                                                                <Box sx={{ maxWidth: '9rem' }}>
                                                                    <Input
                                                                        name='account_number'
                                                                        label='Número da conta'
                                                                        placeholder='00000'
                                                                        type='text'
                                                                        register={{ ...register("account_number", { required: true }) }}
                                                                    />
                                                                </Box>

                                                                <Box sx={{ maxWidth: '4.5rem' }}>
                                                                    <Input
                                                                        name='digit'
                                                                        label='Dígito'
                                                                        placeholder='000'
                                                                        type='text'
                                                                        register={{ ...register("digit", { required: true }) }}
                                                                    />
                                                                </Box>
                                                            </Box>

                                                            <Input
                                                                name='company_name'
                                                                label='Nome/Razão Social'
                                                                placeholder='Nome'
                                                                type='text'
                                                                disabled
                                                                register={{ ...register("company_name", { required: true }) }}
                                                            />

                                                            <Input
                                                                name='identity'
                                                                label='Insira seu CPF ou CNPJ'
                                                                placeholder='000.000.000-00'
                                                                type='tel'
                                                                disabled
                                                                textError="Insira um número válido"
                                                                register={{ ...register("identity", { pattern: Regex.identity }) }} />
                                                        </>
                                                    }

                                                    {/* <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    gap: '.5rem',
                                                    padding: {
                                                        xs: '.4rem 0 2rem',
                                                        md: '.75rem 0 2.3rem'
                                                    }
                                                }}>
                                                    <Checkbox checked={checked} onChange={handleChangeCheckbox} sx={{ padding: '0' }} />
                                                    <Typography fontSize='1rem' paddingBottom='.1rem' sx={{ zIndex: '99' }}>
                                                        Li e concordo com os&nbsp;
                                                        <Link to='termos-de-uso' state={{ type: itemSelectedState.value }}>
                                                            <strong style={{ color: '#0C1C33' }}>
                                                                <u>
                                                                    Termos de uso
                                                                </u>
                                                            </strong>
                                                        </Link>
                                                    </Typography>
                                                </Box> */}

                                                    <Box sx={{
                                                        display: 'flex',
                                                        marginTop: '1rem',
                                                        gap: { xs: '.5rem', md: '1.1875rem' },
                                                        'button': {
                                                            width: { xs: '50%', md: '8.625rem' },
                                                            boxShadow: 'none',
                                                            height: '2.8125rem'
                                                        }
                                                    }}>
                                                        <ButtonOutlined
                                                            name='CANCELAR'
                                                            onClick={() => resetSelected()} />

                                                        <ButtonRectangle
                                                            name='SALVAR'
                                                            type={itemSelectedState.value === '22' ? 'submit' : 'button'}
                                                            disabled={!isBtnActive}
                                                            loadingBtn={isBtnLoading}
                                                            onClick={() => itemSelectedState.value === '25' && onSubmit()}
                                                        />
                                                    </Box>
                                                </form>
                                            </Box>
                                        </Box>
                                    </Fade>
                                </ContentDetails>
                            </Box>
                        </Box>
                    </Box>
                    :
                    <Box sx={{ borderTop: '1px solid #8D9BB5', maxWidth: '44.43rem' }}>
                        <Box sx={{ width: '100%', display: 'flex', marginTop: '2rem', flexDirection: 'column', alignItems: 'center', 'svg': { zIndex: '0' } }}>
                            <IcIturinCoverage />
                            <Box sx={{
                                border: '1.5px solid rgba(10, 168, 227, 0.45)',
                                borderRadius: '10px',
                                maxWidth: '21.875rem',
                                padding: '1.25rem 2.81rem 1.25rem',
                                marginTop: '-30px',
                                zIndex: '2',
                                position: 'relative',
                                backgroundColor: 'white',
                                'button': {
                                    width: '100%',
                                    height: '2.5rem',
                                    marginTop: '.875rem'
                                }
                            }}>
                                <Typography fontSize='1.125rem' textAlign='center' fontWeight={700} lineHeight='30px'>
                                    Para o seu serviço Ituran, <br /> não há alteração disponivel!
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                }
                <ModalEmailBillingPaymentMethodTicket open={showModalEmail} handleClick={(e) => setShowModalEmail(e)} handleConfirm={(e) => setConfirmEmail(e)} />
                <ModalConfirmChange open={isOpenModal} handleClick={(e) => handleClickConfirm(e)} />
                <ModalConfirmChangeDueDate open={isOpenModalDueDate} handleClick={(e) => handleClickConfirmDueDate(e)} />
                <ModalSuccessBillingPaymentMethod open={showModalSuccessBillingPaymentMethod} handleClick={(e) => setShowModalSuccessBillingPaymentMethod(e)} />
                <ModalErrorBillingPaymentMethod open={showModalErrorBillingPaymentMethod} handleClick={(e) => setShowModalErrorBillingPaymentMethod(e)} />
                <ModalErrorBillingPaymentMethodDeadline
                    open={showModalErrorBillingPaymentMethodDeadline}
                    date={dateChange}
                    handleClick={(e) => {
                        resetSelected();
                        setIsChangeDate(false);
                        setShowModalErrorBillingPaymentMethodDeadline(e);
                        isChangeDate &&
                            setDateSelected({
                                text: `${customerPaymentFormsState?.NR_DIA_VENCIMENTO}`,
                                value: `${customerPaymentFormsState?.NR_DIA_VENCIMENTO}`
                            })
                    }} />
            </ContainerBody>
        </Menu>
    );
}

export default ChangePayment;